function StateChange($rootScope, $window, $timeout, authService, $state, $uibModalStack, analyticsService, angularSlideOutPanelStack, managementUserService) {
  $rootScope.$on('$stateChangeSuccess', () => {
    const currentUser = managementUserService.getCurrentUser();

    $timeout(() => {
      $window.scrollTo(0, 0);
    }, 100);

    if (currentUser && currentUser.acceptedTerms) {
      $uibModalStack.dismissAll(); //clear any open modals

      angularSlideOutPanelStack.dismissAll(); //clear any open panels
    }
  });

  // Unauthorized Event Handlers
  $rootScope.$on('unauthorized', () => {
    authService.logout();

    $state.go('login');
  });

  // Setup analytics service
  analyticsService.init();
}

StateChange.$inject = [
  '$rootScope',
  '$window',
  '$timeout',
  'authService',
  '$state',
  '$uibModalStack',
  'analyticsService',
  'angularSlideOutPanelStack',
  'jsSdk.managementUser'
];

export default StateChange;



// WEBPACK FOOTER //
// ./src/stateChange.js